export default [
  {
    type: 'subtitle',
    content: 'Introduction',
  },
  {
    type: 'text',
    content: 'Thank you for choosing to subscribe to the Tamara Smart!',
  },
  {
    type: 'text',
    content:
      'Before reading these Tamara Smart Terms and Conditions <strong>(“Tamara Smart Terms and Conditions”)</strong>, please make sure you have carefully read the Customer Terms and Conditions, as these form part of your agreement with Tamara and should be read together with and in addition to these Tamara Smart Terms and Conditions.',
  },
  {
    type: 'text',
    content:
      'By purchasing a Subscription, you acknowledge and agree to these Tamara Smart Terms and Conditions.',
  },
  {
    type: 'text',
    content:
      'Tamara reserves the right, at its sole and absolute discretion from time to time and for any reason, to modify the features and content described in clause 2 below, modify the billing rates under clause 3 below, modify these Tamara Smart Terms and Conditions. We shall provide you with at least thirty (30) days’ notice of such modifications, unless otherwise permitted or required by applicable laws. Your continued use and payment of your Subscription after such modifications are communicated to you shall constitute an acknowledgment from you that you have read and understood such modifications and accepted them. If, as a result of such modifications, you want to cancel your Subscription, please follow the steps in clause 4 below.',
  },
  {
    type: 'text',
    content:
      'These Tamara Smart Terms and Conditions are set out into three sections (to make these as easy as possible for you to navigate):',
  },
  {
    type: 'text',
    content:
      '<span class="text-decoration-underline">Section One</span> (How to get in touch) – this sets out how you can contact us;',
  },
  {
    type: 'text',
    content:
      '<span class="text-decoration-underline">Section Two</span> (Your Subscription) – this sets out all the information you need to know in relation to your Subscription and how it works;',
  },
  {
    type: 'text',
    content:
      '<span class="text-decoration-underline">Section Three</span> (Definitions) – This includes explanations for what all the capitalised words used in these Tamara Smart Terms and Conditions mean.',
  },
  {
    type: 'subtitle',
    content: 'Section One',
  },
  {
    type: 'text',
    content: '<strong>How to get in touch</strong>',
  },
  {
    type: 'text',
    content:
      'If you’d like to contact us about your Subscription, please use the <a href="https://support.tamara.co/hc/en-us#customers">Customer Help Center.</a>',
  },
  {
    type: 'text',
    content:
      'If you have a Tamara Account with us, don’t forget to check the emails or messages sent to you via your Tamara Account, as that is normally how we will contact you about your Subscription.',
  },
  {
    type: 'subtitle',
    content: 'Section Two',
  },
  {
    type: 'text',
    content: '<strong>Your Subscription</strong>',
  },
  {
    type: 'text',
    content: '<strong>1. Order your Subscription</strong>',
  },
  {
    type: 'text',
    content:
      '<strong>1.1.</strong> Subject to Tamara’s approval and your compliance with these Tamara Smart Terms and Conditions, you may access and use Tamara Smart on a Subscription basis to the extent and for the term stated in the Order Form.',
  },
  {
    type: 'text',
    content:
      '<strong>1.2.</strong> You can purchase a Subscription directly via the Mobile App or the Merchant Platform.',
  },
  {
    type: 'text',
    content:
      '<strong>1.3.</strong> You will only be permitted to purchase a Subscription if:',
  },
  {
    type: 'text',
    content: '<strong>1.3.1.</strong> you are over the age of 18;',
  },
  {
    type: 'text',
    content:
      '<strong>1.3.2.</strong> you are a user of Tamara Services and have an active Tamara Account;',
  },
  {
    type: 'text',
    content:
      '<strong>1.3.3.</strong> your Tamara Account is in good standing, and you have no outstanding or pending payments that are in default.',
  },
  {
    type: 'text',
    content:
      '<strong>1.4.</strong> Your purchase constitutes an offer to us to buy a Subscription. Our acceptance of that offer will take place when we send you a confirmation email to accept your Subscription. If we are unable to accept your order, we will inform you of this by email and will not charge you for the Subscription.',
  },
  {
    type: 'text',
    content: '<strong>2. Your Subscription</strong>',
  },
  {
    type: 'text',
    content:
      '<strong>2.1.</strong> By purchasing a Subscription and paying any recurring monthly subscription fees to maintain your Subscription active, you will have access to the following:',
  },
  {
    type: 'text',
    content:
      '<strong>2.1.1. Cashback:</strong> Cashback of 1% on your use of Tamara Services up to a certain monthly cap as determined by Tamara and notified to you from time to time. Tamara reserves the right to claw back cashbacks in case of Refunds;',
  },
  {
    type: 'text',
    content:
      '<strong>2.1.2. Statements Experience:</strong> to Tamara in a given month from your use of Tamara Services into one monthly payment. The statement will be available to you on the 25th of each month, after which you will have until the first day of the next month to make the one monthly payment. Any use of Tamara Services between the 25th of the month and the 1st day of the next month will be added to the statement for such next month.',
  },
  {
    type: 'text',
    content:
      '<strong>2.1.3. Tamara’s Buyer Protection Program:</strong> The program’s details and terms and conditions are available on our Website.',
  },
  {
    type: 'text',
    content:
      '<strong>2.1.4. Exclusive Deals and Discounts:</strong> Many exclusive deals and discounts.',
  },
  {
    type: 'text',
    content:
      '<strong>2.2.</strong> Tamara Smart shall only apply to the Tamara Services used after the date of your Subscription. Any use of Tamara Services occurring before the date of your Subscription will not be included in your Subscription.',
  },
  {
    type: 'text',
    content: '<strong>3. Payment</strong>',
  },
  {
    type: 'text',
    content:
      '<strong>3.1.</strong> You shall pay for the Subscription in accordance with the payment terms stated in the Order Form.',
  },
  {
    type: 'text',
    content:
      '<strong>3.2.</strong> Your monthly Subscription will start when Tamara confirms your payment and will continue for a term period of thirty (30) days.',
  },
  {
    type: 'text',
    content:
      '<strong>3.3.</strong> When you purchase a monthly Subscription on the Tamara Mobile App, an ongoing/recurring payment plan will automatically be applied to your Tamara Account. At the end of the monthly subscription period, your Subscription will renew automatically for an additional subscription term of thirty (30) days at then-current pricing, unless your Subscription is cancelled by you or us in accordance with these Tamara Smart Terms and Conditions.',
  },
  {
    type: 'text',
    content: '<strong>4. Cancellations</strong>',
  },
  {
    type: 'text',
    content:
      '<strong>4.1.</strong> If you do not wish your Subscription to auto-renew, you can cancel it at any time by logging into your Tamara Account, following the prompts on the account page, and following the instructions. Unless otherwise indicated, cancellation will take effect from the end of the billing period in which you cancel.',
  },
  {
    type: 'text',
    content:
      '<strong>4.2.</strong> All payments are non-refundable and will not be refunded on a pro-rata basis for any cancellation initiated during the Subscription term.',
  },
  {
    type: 'text',
    content:
      '<strong>4.3.</strong> If you fail to make a payment due under your Subscription, Tamara reserves the right, without any liability to you, to terminate the remainder of your Subscription with no further charges to you.',
  },
  {
    type: 'text',
    content:
      '<strong>4.4.</strong> In addition to any other rights Tamara may have under these Tamara Smart Terms and Conditions, Tamara reserves the right in its sole discretion to limit your Tamara Account (including, without limitation, terminating any active Subscription) or take any other action we consider appropriate for any misuse of your Subscription or any non-compliance with these Tamara Smart Terms and Conditions.',
  },
  {
    type: 'text',
    content:
      '<strong>4.5.</strong> If for any reason your Subscription is canceled, terminated, or becomes inactive, you are still responsible for paying any outstanding amounts owed to Tamara. This includes amounts related to the Statements Experience or any other amounts due under your Subscription.',
  },
  {
    type: 'subtitle',
    content: 'Section Three',
  },
  {
    type: 'text',
    content: '<strong>Definitions</strong>',
  },
  {
    type: 'text',
    content:
      'The following references, words, and expressions have the following meanings:',
  },
  {
    type: 'text',
    content:
      '<strong>Customer Terms and Conditions:</strong> means the customer terms and conditions available on our Website.',
  },
  {
    type: 'text',
    content:
      '<strong>Dispute:</strong> means any request for refund, deduction, compensation, counterclaim or dispute of any kind brought by the Customer against the Merchant in respect of the goods or services that resulted in an approved Transaction.',
  },
  {
    type: 'text',
    content:
      '<strong>Identification Information:</strong> means the information required to be provided by the Customer to Tamara in order to create an account for them with Tamara, as collected by Tamara or the Merchant or Merchant Platform (as applicable) for the purposes of providing Tamara Services to Customers.',
  },
  {
    type: 'text',
    content:
      '<strong>Merchant Platform:</strong> means, including but not limited to websites and applications, which allow multiple Merchants to offer goods and services to customers through a single platform',
  },
  {
    type: 'text',
    content:
      '<strong>Merchant:</strong> means any commercial person that permits its customers to utilise the Tamara Services pursuant to an independent agreement, as updated from time to time.',
  },
  {
    type: 'text',
    content:
      '<strong>Mobile App:</strong> means the Tamara mobile application as available to download from the relevant digital stores.',
  },
  {
    type: 'text',
    content:
      '<strong>Order Form:</strong> means an online Subscription order page setting out payment charges and term duration which shall apply to a Subscription package.',
  },
  {
    type: 'text',
    content:
      '<strong>Purchase Order:</strong> means a request submitted by the Customer through a Merchant Platform, the Website, Mobile App, the Merchant’s website, or any other applications or points of sale to use the Tamara Services to purchase goods or services from the relevant Merchant or Merchant Platform.',
  },
  {
    type: 'text',
    content:
      '<strong>Refunds:</strong> means an amount (that may be in dispute) paid by the Customer to a Merchant using the Tamara Services in connection with an approved Transaction which is subsequently returned to the Customer following the resolution of such Dispute.',
  },
  {
    type: 'text',
    content:
      '<strong>Subscription:</strong> means the subscription you purchase in accordance with the Order Form in order to have access to Tamara Smart.',
  },
  {
    type: 'text',
    content:
      '<strong>Tamara:</strong> means Tamara FZE, incorporated and registered in the United Arab Emirates with company number L-602, together with all of its group companies and their affiliates.',
  },
  {
    type: 'text',
    content:
      '<strong>Tamara Account:</strong> means the account created by you (as a customer) to use the Tamara Services, the use and operation of which will be subject to the Customer Terms and Conditions.',
  },
  {
    type: 'text',
    content:
      '<strong>Tamara’s Buyer Protection Program:</strong> as described in the Customer Terms and Conditions.',
  },
  {
    type: 'text',
    content:
      '<strong>Tamara Services:</strong> means the payment and lending services provided by Tamara, as updated from time to time, that you as the customer select on the Merchant’s website, the Merchant Platform or at any other point of sale with the Merchant under which you as the customer choose to purchase goods or services from the Merchant or Merchant Platform using the Tamara Services subject to the Customer Terms and Conditions.',
  },
  {
    type: 'text',
    content:
      '<strong>Tamara Smart:</strong> means a subscription-based Tamara service that allows you to receive the benefits as described in clause 2.1 above, in accordance with these Tamara Smart Terms and Conditions.',
  },
  {
    type: 'text',
    content:
      '<strong>Transaction:</strong> means a request submitted via your Tamara Account, pursuant to a Purchase Order, to make use of the Tamara Services in order to complete and settle such Purchase Order with the relevant Merchant or Merchant Platform.',
  },
  {
    type: 'text',
    content:
      '<strong>Tamara Smart Terms and Conditions</strong> means these Tamara Smart Terms and Conditions as amended from time to time.',
  },
  {
    type: 'text',
    content:
      '<strong>We:</strong> references to “we” or “we” as a possessive, object, or other similar pronouns in these Tamara Smart Terms and Conditions are references to Tamara and its affiliated entities and persons.',
  },
  {
    type: 'text',
    content:
      '<strong>Website:</strong> means Tamara’s website at <a href="https://tamara.co">https://tamara.co.</a>',
  },
  {
    type: 'text',
    content:
      '<strong>You:</strong> References to “you” or the possessive pronoun “your” or other similar pronouns in these Tamara Smart Terms and Conditions are references to the relevant customer referred to in the Identification Information to be provided prior to using the Tamara Services.',
  },
]
